import { FormSection } from "components/MainSectionTemplate/types";
import React from "react";
import BirthdateRow from "../detail/components/BirthdateRow";
import { getMaritalStatus } from "../detail/components/MaritalStatusRow";
import { getInstruction, ContactFormState, ContactFieldMetaData } from "shared/utils/fieldsHelper/contactFields";
import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import OptionalTextAreaInput from "components/ValidatedFields/OptionalTextAreaInput";
import { MaritalStatusRadio } from "contact/detail/components/MaritalStatusRadio";
import { OptionalDatePicker } from "components/DatePicker/OptionalDatePicker";
import moment from "moment";
import { newLineToBr } from "utilities/newlinetobr";

export const otherDetailSection = (
  formState: ContactFormState,
  fieldMetaData: ContactFieldMetaData
): FormSection => {
  return {
    type: "collapsable",
    key: "contactOtherDetails",
    title: RESX.Company.OtherDetails,
    fields: [{
      ...fieldMetaData.socialSecurity.fields(),
      key: "socialSecurity",
      label: RESX.Contact.SocialSecurity,
      render: () => <div>{formState.socialSecurity}</div>,
      inPageEdit: {
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.contact.maxSocialSecurityLength}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.socialSecurity,
        submitChange: (value: string) => {
          const instruction = getInstruction(formState, {
            socialSecurity: value,
          });
          return window.CoreApi.Contact.Update(instruction);
        }
      }
    }, {
      ...fieldMetaData.birthdate.fields(),
      key: "birthdate",
      label: RESX.Contact.DateOfBirth,
      render: () => <BirthdateRow birthdate={formState.birthdate} />,
      inPageEdit: {
        initialValue: formState.birthdate,
        render: ({ value, onChange }) => (
          <OptionalDatePicker
            focusOnMount
            value={value}
            onChange={v => onChange(v)}
            minDate={moment.utc("1900-01-01")}
            maxDate={moment.utc()}
            validatorKey="contactBirthdate"
          />
        ),
        type: "confirmOrCancelButton",
        submitChange: (value: moment.Moment | null) => {
          const instruction = getInstruction(formState, {
            birthdate: value?.toDate(),
          });
          return window.CoreApi.Contact.Update(instruction);
        }
      }

    }, {
      ...fieldMetaData.birthplace.fields(),
      key: "birthplace",
      label: RESX.Contact.PlaceOfBirth,
      render: () => <div>{formState.birthplace}</div>,
      inPageEdit: {
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.contact.maxBirthPlaceLength}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.birthplace,
        submitChange: (value: string) => {
          const instruction = getInstruction(formState, {
            birthplace: value,
          });
          return window.CoreApi.Contact.Update(instruction);
        }
      }
    }, {
      ...fieldMetaData.maritalStatus.fields(),
      key: "maritalStatus",
      label: RESX.Contact.MaritalStatus,
      render: () => getMaritalStatus(formState.maritalStatus),
      inPageEdit: {
        render: ({ value, onChange }) => (
          <div className="main-section-template-fields-padding">
            <MaritalStatusRadio
              value={value || "unknown"}
              onChange={v => onChange(v, true)}
            />
          </div>
        ),
        type: "custom",
        initialValue: formState.maritalStatus,
        submitChange: (value) => {
          const instruction = getInstruction(formState, {
            maritalStatus: value,
          });
          return window.CoreApi.Contact.Update(instruction);
        }
      }
    }, {
      ...fieldMetaData.additional.fields(),
      key: "additionalInformation",
      label: RESX.Company.AdditionalInformation,
      render: () => newLineToBr(formState.additionalInformation),
      inPageEdit: {
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextAreaInput
            focusOnMount
            rows={3}
            value={value}
            onChange={onChange}
            onCtrlEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.contact.maxAdditionalLength}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.additionalInformation,
        submitChange: (value: string) => {
          const instruction = getInstruction(formState, { additional: value });
          return window.CoreApi.Contact.Update(instruction);
        }
      }
    }]
  }
}
